import { IOption } from "../../../types/common";

const isEntireClasses = (options: Array<IOption>) => {
  return !!options.find((option) => option.value === 'all')
}

export default isEntireClasses;
